export default {
    /* GET_QUALITATIVE_NOTES
    ---------------------------------------------------------------
    */
    GET_QUALITATIVE_NOTES_REQUEST: state => {
        state.qualitativeNotesLoading = true
    },
    GET_QUALITATIVE_NOTES_SUCCESS: (state, data) => {
        state.qualitativeNotes = data.results
        state.qualitativeNotesLoading = false
    },
    GET_QUALITATIVE_NOTES_FAILURE: state => {
        state.qualitativeNotesLoading = false
    },
    /* GET_QUALITATIVE_NOTES
    ---------------------------------------------------------------
    */
    SET_QUALITATIVE_NOTES_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_QUALITATIVE_NOTES_FILTERS: state => {
        state.filters = state.setInitialQualitativeNotesFilters()
    },
    GET_CODES_SUCCESS: (state, data) => {
        state.codes = data.results
    },
    GET_REPORT_ITEM_PLATE_ORDERS_REQUEST: state => {
        state.reportItemPlateOrdersLoading = true
    },
    GET_REPORT_ITEM_PLATE_ORDERS_SUCCESS: (state, data) => {
        state.reportItemPlateOrders = data.results
        state.reportItemPlateOrdersLoading = false
    },
    GET_REPORT_ITEM_PLATE_ORDERS_FAILURE: state => {
        state.reportItemPlateOrdersLoading = false
    },
    GET_REPORT_ITEM_PLATES_REQUEST: state => {
        state.reportItemPlatesLoading = true
    },
    GET_REPORT_ITEM_PLATES_SUCCESS: (state, data) => {
        state.reportItemPlates = data.results
        state.reportItemPlatesLoading = false
    },
    GET_REPORT_ITEM_PLATES_FAILURE: state => {
        state.reportItemPlatesLoading = false
    },
    CLEAR_REPORT_ITEM_PLATES: state => {
        state.reportItemPlates = []
    },
    CLEAR_REPORT_ITEM_PLATE_ORDERS: state => {
        state.reportItemPlateOrders = []
    },
    SET_REPORT_ITEM_PLATE_FILTERS: (state, filters) => {
        state.reportItemPlateFilters = filters
    },
    CLEAR_REPORT_ITEM_PLATE_FILTERS: state => {
        state.reportItemPlateFilters = state.setInitialReportItemPlateFilters()
    },
}